import { Injectable } from '@angular/core';

import { BehaviorSubject, Observable } from 'rxjs';
import { KeyValuePairModel } from '../models/common.models';

@Injectable({
  providedIn: 'root',
})
export class GlobalFilterService {
  constructor() {}
  // the available sites
  public sites: KeyValuePairModel<number>[] = [];

  // the sites that have been selected in the global filter
  private readonly _selectedSites$ = new BehaviorSubject<number[]>([]);
  public readonly selectedSites$: Observable<number[]> =
    this._selectedSites$.asObservable();

  // setter for the selected sites
  public set selectedSites(sites: number[]) {
    this._selectedSites$.next(sites);
  }

  getCachedSites = (): number[] => {
    const cachedSites = localStorage.getItem('sites');
    if (cachedSites) {
      const sites = cachedSites.split(',').map((x) => parseInt(x));
      return sites;
    }
    return [0];
  }; 
}
